<template>
  <div v-if="isDingTalkSchool" class="enrollment-tb-toolbar">
    <el-checkbox
      :value="onlyTbRemaining"
      :disabled="!schoolDepartmentId"
      @change="onOnlyTbChange">
      仅显示仍有天波ID
    </el-checkbox>
    <el-button
      size="small"
      type="primary"
      plain
      icon="el-icon-search"
      :disabled="!schoolDepartmentId"
      :loading="checking"
      @click="checkTbResidual">
      检查天波残留
    </el-button>
    <el-button
      size="small"
      type="warning"
      plain
      icon="el-icon-delete"
      :disabled="!schoolDepartmentId"
      :loading="deleting"
      @click="deleteTbResidual">
      清除天波（当前筛选）
    </el-button>

    <el-dialog
      title="天波残留检查"
      :visible.sync="summaryVisible"
      width="720px"
      append-to-body
      :close-on-click-modal="false">
      <div v-if="summary" class="tb-summary">
        <el-alert
          :title="summary.TbSyncEnabled
            ? `当前筛选范围内仍有 ${summary.TotalCount} 名学生保留天波 Id（归档 ${summary.ArchiveCount}，休学主表 ${summary.SuspendOnMainCount}）`
            : '当前学校未开启天波同步或未配置天波组织，无需清理'"
          :type="summary.TotalCount > 0 ? 'warning' : 'success'"
          :closable="false"
          show-icon
          style="margin-bottom: 12px;" />
        <el-table
          v-if="(summary.Samples || []).length"
          :data="summary.Samples"
          border
          stripe
          size="small"
          max-height="360"
          empty-text="暂无样本">
          <el-table-column prop="StuName" label="姓名" min-width="100" />
          <el-table-column prop="StuCode" label="学号" min-width="110" show-overflow-tooltip />
          <el-table-column prop="SchoolStatusName" label="状态" width="80" align="center" />
          <el-table-column prop="SourceDepartmentName" label="原班级" min-width="140" show-overflow-tooltip />
          <el-table-column prop="TbThirdPartId" label="天波ID" width="100" align="center" />
        </el-table>
        <p v-if="summary.TotalCount > (summary.Samples || []).length" class="tb-summary__hint">
          仅展示前 {{ (summary.Samples || []).length }} 条，清除时将处理全部 {{ summary.TotalCount }} 人。
        </p>
      </div>
      <div slot="footer">
        <el-button @click="summaryVisible = false">关闭</el-button>
        <el-button
          type="warning"
          :disabled="!summary || !summary.TotalCount || !summary.TbSyncEnabled"
          :loading="deleting"
          @click="deleteTbResidual(true)">
          立即清除
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  checkArchiveTbResidual,
  batchDeleteArchiveTbResidual
} from '../api/modules/studentEnrollment';
import dingTalkSchoolMixin from '../mixins/dingTalkSchoolMixin';

export default {
  name: 'EnrollmentTbResidualToolbar',
  mixins: [dingTalkSchoolMixin],
  props: {
    scopeKind: {
      type: Number,
      required: true
    },
    schoolDepartmentId: {
      type: Number,
      default: 0
    },
    filterParams: {
      type: Object,
      default: () => ({})
    },
    onlyTbRemaining: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checking: false,
      deleting: false,
      summaryVisible: false,
      summary: null
    };
  },
  watch: {
    schoolDepartmentId: {
      immediate: true,
      handler(schoolId) {
        this.loadCurrentSchoolSchType(schoolId);
      }
    },
    isDingTalkSchool(val) {
      if (!val) {
        this.$emit('update:onlyTbRemaining', false);
        this.$emit('filter-change', false);
      }
    }
  },
  methods: {
    buildRequest(extra = {}) {
      return {
        SchoolDepartmentId: this.schoolDepartmentId,
        ScopeKind: this.scopeKind,
        ...this.filterParams,
        ...extra
      };
    },
    onOnlyTbChange(value) {
      this.$emit('update:onlyTbRemaining', value);
      this.$emit('filter-change', value);
    },
    checkTbResidual() {
      if (!this.schoolDepartmentId) {
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      this.checking = true;
      checkArchiveTbResidual(this.buildRequest())
        .then((res) => {
          this.checking = false;
          if (res.data && res.data.success) {
            this.summary = res.data.response || null;
            this.summaryVisible = true;
            return;
          }
          this.$message.error((res.data && res.data.msg) || '检查失败');
        })
        .catch(() => {
          this.checking = false;
        });
    },
    deleteTbResidual(fromDialog = false) {
      if (!this.schoolDepartmentId) {
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      const runDelete = () => {
        this.deleting = true;
        batchDeleteArchiveTbResidual(this.buildRequest())
          .then((res) => {
            this.deleting = false;
            if (res.data && res.data.success) {
              const result = res.data.response || {};
              const type = (result.FailCount || 0) > 0 ? 'warning' : 'success';
              this.$message({ message: res.data.msg || '清除完成', type, duration: 5000 });
              this.summaryVisible = false;
              this.$emit('deleted');
              return;
            }
            this.$message.error((res.data && res.data.msg) || '清除失败');
          })
          .catch(() => {
            this.deleting = false;
          });
      };

      const countHint = this.summary && this.summary.TotalCount
        ? `将处理当前筛选范围内约 ${this.summary.TotalCount} 名学生`
        : '将处理当前筛选范围内所有仍保留天波 Id 的学生';
      this.$confirm(
        `${countHint}：调用天波删除接口并清空本地 TbThirdPartId，不删除本地毕业/转退档案。是否继续？`,
        '清除天波数据',
        { type: 'warning', confirmButtonText: '确认清除', cancelButtonText: '取消' }
      ).then(() => runDelete()).catch(() => {
        if (!fromDialog) return;
      });
    }
  }
};
</script>

<style scoped>
.enrollment-tb-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.enrollment-tb-toolbar >>> .el-checkbox {
  margin-right: 0;
}

.enrollment-tb-toolbar >>> .el-checkbox__label {
  font-size: 12px;
  color: #475569;
}

.tb-summary__hint {
  margin: 10px 0 0;
  font-size: 12px;
  color: #64748b;
}
</style>
